import { TextField } from "@material-ui/core";
import { useTranslation } from 'react-i18next';
import { Autocomplete, AutocompleteChangeReason } from "@material-ui/lab";
import React, { ChangeEvent } from "react";

interface IProductListSearchProps<T> {
    onItemSelection: (object: T | null) => void;
    productList: T[];
    getOptionLabelFunction?: (obj: T) => string;
    renderOptionFunction?: (obj: T) => JSX.Element;
}

export function ProductListSearch<T>({
    onItemSelection,
    productList,
    getOptionLabelFunction,
    renderOptionFunction
}: IProductListSearchProps<T>) {
    const { t } = useTranslation();

    function openItem(event: ChangeEvent<{}>, item: any | null, reason: AutocompleteChangeReason) {
        if (reason === "clear") { return; }

        onItemSelection(item);
    }
    return <div className="search" id="search">
        <Autocomplete
            noOptionsText={t("misc.noOptions")}
            getOptionLabel={getOptionLabelFunction}
            onChange={openItem}
            renderInput={(params) => <TextField {...params} placeholder={t("menu.subcategories.search")} name={"search"} variant="outlined" />}
            options={productList || []}
            renderOption={renderOptionFunction}
            data-component-name={'SEARCH_PRODUCTS'}

        />
    </div>;
}
